import * as React from "react"
import { Segment, Dimmer, Loader, SemanticSIZES } from "semantic-ui-react"

interface ILoading {
  text?: React.ReactText
  size?: SemanticSIZES
  style?: React.CSSProperties
}

const Loading = ({
  text = "" as React.ReactText,
  size = "medium",
  style,
}: ILoading) => (
  <Dimmer inverted active className="semantic-ui-is-stupid" style={style}>
    <Loader inverted size={size}>
      {text}
    </Loader>
  </Dimmer>
)

export default Loading
